function DirectorySearchBarItemWrapper({ children }) {
  return <div className="md:w-full w-1/2 px-1 pb-2">{children}</div>;
}

export default DirectorySearchBarItemWrapper;
